import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'workwear_user_profile';

const UserContext = createContext(null);

function loadProfile() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { name: '', department: '' };
  } catch {
    return { name: '', department: '' };
  }
}

export function UserProvider({ children }) {
  const [profile, setProfileState] = useState(loadProfile);

  const setProfile = useCallback(({ name, department }) => {
    const next = {
      name: name.trim(),
      department: department.trim(),
    };
    setProfileState(next);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }, []);

  const clearProfile = useCallback(() => {
    setProfileState({ name: '', department: '' });
    sessionStorage.removeItem(STORAGE_KEY);
  }, []);

  const hasProfile = Boolean(profile.name && profile.department);

  return (
    <UserContext.Provider value={{ profile, setProfile, clearProfile, hasProfile }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used within UserProvider');
  return ctx;
}
